/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as EntryRouteImport } from './routes/entry'
import { Route as HelpRouteImport } from './routes/help'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SessionLapsedRouteImport } from './routes/session-lapsed'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppAttachmentsAttachmentIdRouteImport } from './routes/_app.attachments.$attachmentId'
import { Route as AppQueriesIndexRouteImport } from './routes/_app.queries.index'
import { Route as AppQueriesQueryIdRouteImport } from './routes/_app.queries.$queryId'
import { Route as AppQueriesNewRouteImport } from './routes/_app.queries.new'
import { Route as AppVettingRequestsVettingIdRouteImport } from './routes/_app.vetting-requests.$vettingId'
import { Route as AppVettingIndexRouteImport } from './routes/_app.vetting.index'
import { Route as AppVettingVettingIdRouteImport } from './routes/_app.vetting.$vettingId'
import { Route as AppVettingNewRouteImport } from './routes/_app.vetting.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const EntryRoute = EntryRouteImport.update({
  id: '/entry',
  path: '/entry',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionLapsedRoute = SessionLapsedRouteImport.update({
  id: '/session-lapsed',
  path: '/session-lapsed',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppAttachmentsAttachmentIdRoute =
  AppAttachmentsAttachmentIdRouteImport.update({
    id: '/attachments/$attachmentId',
    path: '/attachments/$attachmentId',
    getParentRoute: () => AppRoute,
  } as any)
const AppQueriesIndexRoute = AppQueriesIndexRouteImport.update({
  id: '/queries/',
  path: '/queries/',
  getParentRoute: () => AppRoute,
} as any)
const AppQueriesQueryIdRoute = AppQueriesQueryIdRouteImport.update({
  id: '/queries/$queryId',
  path: '/queries/$queryId',
  getParentRoute: () => AppRoute,
} as any)
const AppQueriesNewRoute = AppQueriesNewRouteImport.update({
  id: '/queries/new',
  path: '/queries/new',
  getParentRoute: () => AppRoute,
} as any)
const AppVettingRequestsVettingIdRoute =
  AppVettingRequestsVettingIdRouteImport.update({
    id: '/vetting-requests/$vettingId',
    path: '/vetting-requests/$vettingId',
    getParentRoute: () => AppRoute,
  } as any)
const AppVettingIndexRoute = AppVettingIndexRouteImport.update({
  id: '/vetting/',
  path: '/vetting/',
  getParentRoute: () => AppRoute,
} as any)
const AppVettingVettingIdRoute = AppVettingVettingIdRouteImport.update({
  id: '/vetting/$vettingId',
  path: '/vetting/$vettingId',
  getParentRoute: () => AppRoute,
} as any)
const AppVettingNewRoute = AppVettingNewRouteImport.update({
  id: '/vetting/new',
  path: '/vetting/new',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/entry': typeof EntryRoute
  '/help': typeof HelpRoute
  '/privacy': typeof PrivacyRoute
  '/session-lapsed': typeof SessionLapsedRoute
  '/terms': typeof TermsRoute
  '/home': typeof AppHomeRoute
  '/profile': typeof AppProfileRoute
  '/attachments/$attachmentId': typeof AppAttachmentsAttachmentIdRoute
  '/queries/$queryId': typeof AppQueriesQueryIdRoute
  '/queries/new': typeof AppQueriesNewRoute
  '/vetting-requests/$vettingId': typeof AppVettingRequestsVettingIdRoute
  '/vetting/$vettingId': typeof AppVettingVettingIdRoute
  '/vetting/new': typeof AppVettingNewRoute
  '/queries/': typeof AppQueriesIndexRoute
  '/vetting/': typeof AppVettingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/entry': typeof EntryRoute
  '/help': typeof HelpRoute
  '/privacy': typeof PrivacyRoute
  '/session-lapsed': typeof SessionLapsedRoute
  '/terms': typeof TermsRoute
  '/home': typeof AppHomeRoute
  '/profile': typeof AppProfileRoute
  '/attachments/$attachmentId': typeof AppAttachmentsAttachmentIdRoute
  '/queries/$queryId': typeof AppQueriesQueryIdRoute
  '/queries/new': typeof AppQueriesNewRoute
  '/vetting-requests/$vettingId': typeof AppVettingRequestsVettingIdRoute
  '/vetting/$vettingId': typeof AppVettingVettingIdRoute
  '/vetting/new': typeof AppVettingNewRoute
  '/queries': typeof AppQueriesIndexRoute
  '/vetting': typeof AppVettingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/entry': typeof EntryRoute
  '/help': typeof HelpRoute
  '/privacy': typeof PrivacyRoute
  '/session-lapsed': typeof SessionLapsedRoute
  '/terms': typeof TermsRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/attachments/$attachmentId': typeof AppAttachmentsAttachmentIdRoute
  '/_app/queries/$queryId': typeof AppQueriesQueryIdRoute
  '/_app/queries/new': typeof AppQueriesNewRoute
  '/_app/vetting-requests/$vettingId': typeof AppVettingRequestsVettingIdRoute
  '/_app/vetting/$vettingId': typeof AppVettingVettingIdRoute
  '/_app/vetting/new': typeof AppVettingNewRoute
  '/_app/queries/': typeof AppQueriesIndexRoute
  '/_app/vetting/': typeof AppVettingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/entry'
    | '/help'
    | '/privacy'
    | '/session-lapsed'
    | '/terms'
    | '/home'
    | '/profile'
    | '/attachments/$attachmentId'
    | '/queries/$queryId'
    | '/queries/new'
    | '/vetting-requests/$vettingId'
    | '/vetting/$vettingId'
    | '/vetting/new'
    | '/queries/'
    | '/vetting/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/entry'
    | '/help'
    | '/privacy'
    | '/session-lapsed'
    | '/terms'
    | '/home'
    | '/profile'
    | '/attachments/$attachmentId'
    | '/queries/$queryId'
    | '/queries/new'
    | '/vetting-requests/$vettingId'
    | '/vetting/$vettingId'
    | '/vetting/new'
    | '/queries'
    | '/vetting'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/entry'
    | '/help'
    | '/privacy'
    | '/session-lapsed'
    | '/terms'
    | '/_app/home'
    | '/_app/profile'
    | '/_app/attachments/$attachmentId'
    | '/_app/queries/$queryId'
    | '/_app/queries/new'
    | '/_app/vetting-requests/$vettingId'
    | '/_app/vetting/$vettingId'
    | '/_app/vetting/new'
    | '/_app/queries/'
    | '/_app/vetting/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  EntryRoute: typeof EntryRoute
  HelpRoute: typeof HelpRoute
  PrivacyRoute: typeof PrivacyRoute
  SessionLapsedRoute: typeof SessionLapsedRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entry': {
      id: '/entry'
      path: '/entry'
      fullPath: '/entry'
      preLoaderRoute: typeof EntryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/session-lapsed': {
      id: '/session-lapsed'
      path: '/session-lapsed'
      fullPath: '/session-lapsed'
      preLoaderRoute: typeof SessionLapsedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/attachments/$attachmentId': {
      id: '/_app/attachments/$attachmentId'
      path: '/attachments/$attachmentId'
      fullPath: '/attachments/$attachmentId'
      preLoaderRoute: typeof AppAttachmentsAttachmentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/queries/': {
      id: '/_app/queries/'
      path: '/queries'
      fullPath: '/queries/'
      preLoaderRoute: typeof AppQueriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/queries/$queryId': {
      id: '/_app/queries/$queryId'
      path: '/queries/$queryId'
      fullPath: '/queries/$queryId'
      preLoaderRoute: typeof AppQueriesQueryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/queries/new': {
      id: '/_app/queries/new'
      path: '/queries/new'
      fullPath: '/queries/new'
      preLoaderRoute: typeof AppQueriesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vetting-requests/$vettingId': {
      id: '/_app/vetting-requests/$vettingId'
      path: '/vetting-requests/$vettingId'
      fullPath: '/vetting-requests/$vettingId'
      preLoaderRoute: typeof AppVettingRequestsVettingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vetting/': {
      id: '/_app/vetting/'
      path: '/vetting'
      fullPath: '/vetting/'
      preLoaderRoute: typeof AppVettingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vetting/$vettingId': {
      id: '/_app/vetting/$vettingId'
      path: '/vetting/$vettingId'
      fullPath: '/vetting/$vettingId'
      preLoaderRoute: typeof AppVettingVettingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vetting/new': {
      id: '/_app/vetting/new'
      path: '/vetting/new'
      fullPath: '/vetting/new'
      preLoaderRoute: typeof AppVettingNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppHomeRoute: typeof AppHomeRoute
  AppProfileRoute: typeof AppProfileRoute
  AppAttachmentsAttachmentIdRoute: typeof AppAttachmentsAttachmentIdRoute
  AppQueriesQueryIdRoute: typeof AppQueriesQueryIdRoute
  AppQueriesNewRoute: typeof AppQueriesNewRoute
  AppVettingRequestsVettingIdRoute: typeof AppVettingRequestsVettingIdRoute
  AppVettingVettingIdRoute: typeof AppVettingVettingIdRoute
  AppVettingNewRoute: typeof AppVettingNewRoute
  AppQueriesIndexRoute: typeof AppQueriesIndexRoute
  AppVettingIndexRoute: typeof AppVettingIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHomeRoute: AppHomeRoute,
  AppProfileRoute: AppProfileRoute,
  AppAttachmentsAttachmentIdRoute: AppAttachmentsAttachmentIdRoute,
  AppQueriesQueryIdRoute: AppQueriesQueryIdRoute,
  AppQueriesNewRoute: AppQueriesNewRoute,
  AppVettingRequestsVettingIdRoute: AppVettingRequestsVettingIdRoute,
  AppVettingVettingIdRoute: AppVettingVettingIdRoute,
  AppVettingNewRoute: AppVettingNewRoute,
  AppQueriesIndexRoute: AppQueriesIndexRoute,
  AppVettingIndexRoute: AppVettingIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  EntryRoute: EntryRoute,
  HelpRoute: HelpRoute,
  PrivacyRoute: PrivacyRoute,
  SessionLapsedRoute: SessionLapsedRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
